import * as React from "react";
import { SearchableSelect } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import { ConnectProto } from "@racoon/api";
import { useListPickupLocationsQuery } from "~/shared/api/pickup-locations/pickup-locations.grpc";
import { OnboardingField } from "./onboarding-layout";

/** Site selector for steps 4 and 5: any of the provider's sites, not only the customer's. */
export const LocationPicker: React.FC<{
  providerId?: number;
  value?: bigint;
  label: string;
  onChange: (locationId: bigint) => void;
}> = ({ providerId, value, label, onChange }) => {
  const t = useT();

  // Active sites only: groups and schedules must not be attached to an archived one.
  // Same args as step 3's "existing" list, so both read one cache entry.
  const { data, isFetching } = useListPickupLocationsQuery(
    {
      serviceProviderIds: providerId ? [BigInt(providerId)] : [],
      statuses: [ConnectProto.LocationStatus.ACTIVE],
    },
    { skip: !providerId },
  );

  const options = React.useMemo(
    () =>
      (data?.pickupLocations ?? []).map((location) => ({
        id: String(location.id),
        name: location.name,
      })),
    [data],
  );

  return (
    <OnboardingField label={label} htmlFor="onboarding-step-location" labelWidth={80}>
      <SearchableSelect
        id="onboarding-step-location"
        value={value != null ? String(value) : ""}
        onChange={(next) => onChange(BigInt(next))}
        options={options}
        loading={isFetching}
        placeholder={t(Namespace.Customers, "onboarding.selectPlaceholder")}
        searchPlaceholder={t(Namespace.Customers, "searchPlaceholder")}
      />
    </OnboardingField>
  );
};
